import { toast as sonnerToast } from 'sonner';

export const toast = {
  success: (message: string) => {
    sonnerToast.success(message, {
      duration: 5000,
    });
  },
  error: (message: string) => {
    sonnerToast.error(message, {
      duration: 5000,
    });
  },
  warning: (message: string) => {
    sonnerToast.warning(message, {
      duration: 5000,
    });
  },
  info: (message: string) => {
    sonnerToast.info(message, {
      duration: 5000,
    });
  },
};

export function handleApiError(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'An unexpected error occurred';
}

export function showErrorToast(error: unknown) {
  const message = handleApiError(error);
  toast.error(message);
}
